import service from './request'

// 获取短信验证码
export const SMS = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/sms/send",
  method: "post",
  data
});

// 切换主体空间
export const switchBody = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/account-admin/revise/switchWorkspace",
  method: "post",
  data
});

// 效验验证码坐标
export const checkoutImageAuthCode = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/user/checkoutImageAuthCode",
  method: "post",
  data
});

// 效验验证码坐标
export const createImageAuthCode = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/user/createImageAuthCode",
  method: "post",
  data
});

// 登录后获取供应链token
export const getProductToken = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/account-admin/login/product",
  method: "post",
  data
});

// 登录后获取供应链token
export const typeList = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/employeePoints/typeList",
  method: "post",
  data
});

// 成员点数消耗记录列表页
export const recordPage = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/employeePoints/recordPage",
  method: "post",
  data
});

// 成员配额列表页
export const quotaList = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/employeePoints/page",
  method: "post",
  data
});

// 更新成员配额
export const updateTotalPoints = (data) => service({
  baseURL: process.env.VUE_APP_API,
  url: `/user-service/employeePoints/updateTotalPoints`,
  method: "post",
  data
});

// 获取使用模式
export const getAiPointsType = () => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/employeePoints/getAiPointsType",
  method: "get"
});

// 更新使用模式
export const updateAiPointsType = (type) => service({
  baseURL: process.env.VUE_APP_API,
  url: `/user-service/employeePoints/updateAiPointsType?type=${type}`,
  method: "get"
});

// 获取使用模式
export const platUsedPoints = () => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/employeePoints/platUsedPoints",
  method: "post"
});

// ---------------------成员相关---------------------------
// 成员列表
export const getMemberList = (data) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/employee/list",
  method: "post",
  data
});

// 删除成员
export const delMember = (params) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/employee/del/" + params.id,
  method: "get",
});

// 启用/停用成员
export const memberStatus = (data) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/employee/updateStatus",
  method: "post",
  data
});

// 添加/更新成员
export const addOrEdit = (data) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/employee/addOrUpdate",
  method: "post",
  data
});

// 获取成员
export const getMember = (params) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/employee/get/" + params.id,
  method: "get",
});

// 生成邀请链接
export const generateLink = (data) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/employee/generateLink",
  method: "post",
  data
});

// 转让负责人
export const makeOver = (data) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/employee/makeOver",
  method: "post",
  data
});

// ---------------------部门相关---------------------------
// 部门列表
export const getDeptList = (data) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/dept/list",
  method: "post",
  data
});

// 删除部门
export const delDept = (params) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/dept/del/" + params.id,
  method: "get",
});

// 启用/停用部门
export const reptStatus = (data) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/dept/updateStatus",
  method: "post",
  data
});

// 转移成员---部门
export const transferMemberByDept = (data) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/dept/transfer",
  method: "post",
  data
});

// 添加/更新部门
export const addOrEditDept = (data) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/dept/addOrUpdate",
  method: "post",
  data
});

// 获取二级部门
export const dreptListTwo = (data) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/dept/listTwo",
  method: "post",
  data
});

// 获取部门
export const getDept = (params) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/dept/get/" + params.id,
  method: "get",
});

// 获取当前部门下的成员
export const getEmployeeByDeptId = (params) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/employee/getEmployeeByDeptId/" + params.id,
  method: "get",
});

// ---------------------角色相关------------------
// 角色列表
export const getRoleList = (data) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/role/list",
  method: "post",
  data
});

// 删除角色
export const delRole = (id) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/role/del/" + id,
  method: "get",
});

// 启用/停用角色
export const roleStatus = (data) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/role/updateStatus",
  method: "post",
  data
});

// 获取角色
export const getRole = (id) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/role/get/" + id,
  method: "get",
});

// 转移成员---角色
export const transferMemberByRole = (data) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/role/transfer",
  method: "post",
  data
});

// 添加/更新角色
export const updateRole = (data) => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/role/addOrUpdate",
  method: "post",
  data
});

// 获取所有菜单列表
export const menuList = () => service({
  baseURL: process.env.VUE_APP_API,
  url: "/user-service/menu/menuList",
  method: "get",
});